export default class Status {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Status.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$hide = this.DOM.$el.querySelector(this.options.selectorHide)
        this.DOM.$hide.addEventListener('click', this.onHideClick.bind(this), { once: false, passive: true })
        if (this.DOM.$el.dataset.autoclose) {
            let autoclose = Number(this.DOM.$el.dataset.autoclose)
            let timeToClose = !isNaN(autoclose) && autoclose > 5000 ? autoclose : 10000
            setTimeout(() => {
                this.DOM.$hide.dispatchEvent(new Event('click'))
            }, timeToClose)
        }
    }

    onHideClick() {
        this.DOM.$el.style.height = `${this.DOM.$el.getBoundingClientRect().height}px`

        this.DOM.$el.addEventListener('animationend', () => {
            this.DOM.$el.remove()
        }, { once: true, passive: true })

        this.DOM.$el.classList.add(this.options.classNameIsHiding)
    }
}

Status.prototype.defaults = {
    classNameIsHiding: 'is-hiding',
    selectorHide: '.js-statusHide',
}